<a class="service-card" [routerLink]="link">
    <div class="service-card__image">
        <img [src]="image" [alt]="translateHelper.localize(service.name)">
    </div>
    <div class="service-card__body">
        <div class="service-card__professional" *ngIf="showProfessional && service.professional">
            {{ translateHelper.localize(service.professional.title) || service.professional.name }}
        </div>
        <div class="service-card__name">{{ translateHelper.localize(service.name) }}</div>
        <div class="service-card__facts">
            <span *ngIf="service.hours"><mat-icon>schedule</mat-icon>{{"hours_value"|translate: { hours: service.hours } }}</span>
            <span><mat-icon>event</mat-icon>{{ ('booking_type_' + service.dateType)|translate }}</span>
        </div>
        <div class="service-card__footer">
            <span class="service-card__price">
                {{ (service.taxedPrice || service.price)|currencyFormat }}<small>{{ priceSuffixKey|translate }}</small>
            </span>
            <span class="btn btn-primary btn-sm">{{"view_service"|translate}}</span>
        </div>
    </div>
</a>
